module.exports = __webpack_public_path__ + "media/Audio17_a.38926d60.wav";